// extracted by mini-css-extract-plugin
export default {"halfWidth":"edit-form_halfWidth__xP1BI"};